// tooltipSteps.ts
import React from 'react';
import { Image, View } from 'react-native';
import { TToolTipProps } from './ToolTip';
import { ArrowLeftToolTip } from '../../../resources/svgComponents/ArrowLeftToolTip';
import { ArrowUpToolTip } from '../../../resources/svgComponents/ArrowUpToolTip copy';
import { ArrowDownToolTip } from '../../../resources/svgComponents/ArrowDownToolTip';
const beeAssessmentIcon = require('../../../resources/images/beeAssessment.png');

const icon = (
  <Image source={beeAssessmentIcon} style={{ width: 60, height: 60, resizeMode: 'contain' }} />
);

export type TToolTipSteps = {
  name?: string;
  showHeader?: boolean;
  lines: string[];
  buttonText?: string;
  onPress?: () => void;
  onClose?: () => void;
  icon?: React.ReactNode;
  position?: {
    top: number;
    left: number;
  };
  positionMobile?: {
    top: number;
    left: number;
  };
  arrow?: React.ReactNode;
  arrowMobile?: React.ReactNode;
  arrowPosition?: {
    top: number;
    left: number;
  };
  arrowPositionMobile?: {
    top: number;
    left: number;
  };
  footerText?: string;
};

export const TOOLTIP_STEPS: (TToolTipSteps & { id: string })[] = [
  {
    id: 'Welcome',
    lines: [
      'I’m Professor Bee!',
      'Thanks for joining Number Hive!',
      'Let me show you around quickly.',
    ],
    buttonText: 'Get started',
    icon: icon,
    position: { left: 20, top: 250 },
    positionMobile: { left: 80, top: 150 },
    showHeader: true,
  },
  {
    id: 'howToPlay',
    lines: ['Here’s where you can go', 'for help on playing the game.'],
    buttonText: 'Next',
    position: { left: 250, top: -250 },
    positionMobile: { left: -20, top: -350 },
    icon: icon,
    showHeader: false,
    arrow: <ArrowLeftToolTip />,
    arrowMobile: <ArrowDownToolTip color="white" />,
    arrowPosition: { top: 200, left: -80 },
    arrowPositionMobile: { top: 280, left: 120 },
  },

  {
    id: 'nectarCount',
    lines: [
      'You earn Nectar when you',
      'play. You can spend Nectar points in the Nectar Nook.',
      'You can also see your',
      'achievements in there!',
    ],
    buttonText: 'Next',
    icon: icon,
    showHeader: false,
    position: { left: -40, top: 200 },
    positionMobile: { left: -130, top: -350 },
    arrow: <ArrowUpToolTip />,
    arrowMobile: <ArrowUpToolTip color="white" />,
    arrowPosition: { top: -90, left: 80 },
    arrowPositionMobile: { top: -120, left: 20 },
  },
  {
    id: 'hiveGym',
    lines: [
      'Hive Gym is where you can',
      'work out your brain & play',
      'any game you want. It',
      'won’t be included in your learning journey but you',
      'can earn Nectar!',
    ],
    buttonText: 'Done',
    icon: icon,
    showHeader: false,
    position: { left: 500, top: -250 },
    positionMobile: { left: 70, top: -380 },
    arrow: <ArrowLeftToolTip />,
    arrowMobile: <ArrowDownToolTip color="white" />,
    arrowPosition: { top: 200, left: -80 },
    arrowPositionMobile: { top: 300, left: 80 },
  },
  {
    id: 'journey',
    lines: ["Here's your Learning Journey", 'with progress shown.'],
    buttonText: 'Done',
    icon: icon,
    showHeader: false,
    position: { left: 50, top: -320 },
    positionMobile: { left: 0, top: -320 },
    arrow: <ArrowDownToolTip color="black" />,
    arrowMobile: <ArrowDownToolTip color="black" />,
    arrowPosition: { top: 250, left: 100 },
    arrowPositionMobile: { top: 250, left: 80 },
    footerText: "Let's get started!",
  },
];
